/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

/**
 * Date helpers for Agentic AI data (knowledge bases, documents, agents).
 * Agentic AI timestamps carry no zone ("2026-09-24T09:27:29.657076") — they are treated as UTC.
 */
export const parseTimestamp = (value) => {
  if (!value) { return null; }
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(value);
  const date = new Date(hasZone ? value : `${value}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Same format as the Accounts list: "Sep 24, 2026" (formatDateTime adds the time for tooltips).
export const formatDate = (value) => {
  const date = parseTimestamp(value);
  if (!date) { return '—'; }
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatDateTime = (value) => {
  const date = parseTimestamp(value);
  if (!date) { return '—'; }
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
